export const AsteriskCallDirect = {
  Inbound: "Inbound",
  Outbound: "Outbound",
  Conference: "Conference",
  AgentConference: "AgentConference",
  //AgentPhone:"AgentPhone",
  All: "All"

}
